import { object, string } from "yup";

import type { I18nT } from "@lib/dashboardI18n";
import templatableUtil from "@lib/liquid/templatableUtil";
import sharedConstants from "@lib/shared_constants";
import { isPersonalizedHttpUrl, isValidHttpUrl } from "@lib/smsLinkShorteningHelper";

const isLink = (string: string) =>
  templatableUtil.startsWithLiquid(string) || isValidHttpUrl(string) || isPersonalizedHttpUrl(string);

export const getRcsMediaFieldsSchema = (t: I18nT<"rcs-composer">) =>
  object({
    media_url: string()
      .maxLengthIgnoringLiquid(
        sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_MEDIA_URL,
        t("rcs-media-url-too-long", "Media URL must be less than { maxLength } characters", {
          maxLength: sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_MEDIA_URL.toString(),
        })
      )
      .required(t("media-required-rcs-media-message", "Media is required when sending an RCS media message"))
      .test("is-valid-media-url", t("rcs-media-url-invalid-error", "Media URL is invalid"), isLink),
    media_thumbnail_url: string()
      .maxLengthIgnoringLiquid(
        sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_MEDIA_URL,
        t("rcs-media-thumbnail-url-too-long", "Media thumbnail URL must be less than { maxLength } characters", {
          maxLength: sharedConstants.RCS.VALIDATIONS.MAX_CHARACTER_LIMIT_FOR_MEDIA_URL.toString(),
        })
      )
      .optional(),
  });
